import { Button } from "@/atoms-react/button/Button.react.tsx";
import { Modal } from "@/atoms-react/modal/index.react";
import { Base, CardTitle } from "@/atoms-react/text/Text.react";
import { Routes } from "@/features/router.ts";
import type React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

type ModalAuthenticationRequireHelperProps = {
  open: boolean;
  onClose: () => void;
} & React.ComponentPropsWithoutRef<"div">;

export const ModalAuthenticationRequireHelper = ({
  open,
  onClose
}: ModalAuthenticationRequireHelperProps) => {
  const { t } = useTranslation(["pass"]);
  const navigate = useNavigate();
  return (
    <Modal open={open} closable onClose={onClose} className="w-full max-w-lg sm:w-full">
      <div className="flex flex-col p-4">
        <CardTitle className="mb-4 text-center">
          {t("modal_authentication_helper.header")}
        </CardTitle>
        <Base className="mt-6 text-center text-slate-400 dark:text-slate-400">
          {t("modal_authentication_helper.body")}
        </Base>
        <Button
          className={"mt-10 mb-4"}
          onClick={() => {
            navigate(Routes.security);
            onClose();
          }}
        >
          {t("modal_authentication_helper.buttons.access_security")}
        </Button>
        <Button
          className={"mb-4"}
          onClick={() => {
            onClose();
          }}
        >
          {t("modal_authentication_helper.buttons.cancel")}
        </Button>
      </div>
    </Modal>
  );
};
